import React, { Component } from 'react';
import Axios from 'axios';
import Constant from '../Constant';
import '../../css/style.css';
import { getAccessToken } from '../../hooks/AccessToken';

class CityManagement extends Component {
      
    state = {
        countryCode: '',
        CountryData: [],
        StateData: [],
        DataList: [],
        ERROR: true
    }


    //----------------------------------Integrate show State API----------------------------------\\

    getStateByCountry = (countryCode) => {
        try {
            let { accessToken } = getAccessToken();
            let req = {
                'url': Constant.apiBasePath + 'location/state/getAll?countryCode=' + countryCode,
                'method': 'GET',
                'json': true,
                'headers': {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'token': accessToken
                }
            }
            Axios(req).then(response => {
                let data = response.data;
                if(data.status === Constant.statusSuccess) {
                    this.setState({ StateData: data.data, ERROR: false });
                }
                else{
                    alert(data.message);
                    return false;
                }
            }).catch(error => {
                console.log(error);
            })
        }
        catch(err) {
            console.log(err);
        }
    }

    getCityByStateCode = (stateCode) => {
        try {
            let { accessToken } = getAccessToken();
            let req = {
                'url': Constant.apiBasePath + 'location/city/getAll?countryCode=' + this.state.countryCode + '&stateCode=' + stateCode,
                'method': 'GET',
                'json': true,
                'headers': {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'token': accessToken
                }
            }
            Axios(req).then(response => {
                let data = response.data;
                if(data.status === Constant.statusSuccess) {
                    this.setState({ DataList: data.data, ERROR: false });
                }
                else{
                    alert(data.message);
                    return false;
                }
            }).catch(error => {
                console.log(error);
            })
        }
        catch(err) {
            console.log(err);
        }
    }

    handleSubmit = () => {
        try {
            let { accessToken } = getAccessToken();
            let req = {
                'url': Constant.apiBasePath + 'location/country/getAll',
                'method': 'GET',
                'json': true,
                'headers': {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'token': accessToken
                }
            }
            Axios(req).then(response => {
                let data = response.data;
                if(data.status === Constant.statusSuccess) {
                    this.setState({ CountryData: data.data, ERROR: false });
                }
                else{
                    alert(data.message);
                    return false;
                }
            }).catch(error => {
                console.log(error);
            })
        }
        catch(err) {
            console.log(err);
        }
    }

    handleChange = (e) => {
        if(e.target.id === 'countryCode') {
            this.setState({ 'countryCode': e.target.value });
            this.getStateByCountry(e.target.value);
        }
        else if(e.target.id === 'stateCode') {
            this.getCityByStateCode(e.target.value);
        }
    };  

    
    //--------------------------------------------Reload component----------------------------------------------//    

    componentDidMount() {
        this.handleSubmit();
    }

    
    //-------------------------------------------End API-------------------------------------------------------\\     

    render() {
        const { DataList, CountryData, StateData } = this.state;
        let i = 0;
        let bodyData = '';
        let CountryOptions = '';
        let StateOptions = '';


        if(CountryData.length > 0) {
            CountryOptions = CountryData.map(list => {
                return <option key={list.isoCode} id={list.isoCode} value={list.isoCode}>{list.name}</option>
            })
        }

        if(StateData.length > 0) {
            StateOptions = StateData.map(list => {
                return <option key={list.isoCode} id={list.isoCode} value={list.isoCode}>{list.name}</option>
            })
        }

        if(DataList.length > 0) {
            bodyData = DataList.map(el => {
                i++;
                return <tr key={el._id || `${el.name}-${el.stateCode}-${i}`}><td>{i}</td><td>{el.name}</td><td>{el.countryCode}</td><td>{el.stateCode}</td>
                {/* <td>{(el.status === 0)?<span className="text-danger">Deactive</span>:<span className="text-success">Active</span>}</td> */}
                </tr>
            })
        }
        
        return (
            <div className="content-page contest-submissions-page contest-management-page location-management-page city-management-page event-consistent-page">
                <div className="content page-content-spaced">
                    <div className="event-management-header">
                        <div className="header-content">
                            <div className="header-title">
                                <h4 className="page-title-heading">City Management</h4>
                                <p className="header-subtitle">Select country and state to view available cities.</p>
                            </div>
                        </div>
                    </div>

                    <div className="event-management-body">
                        <div className="card contest-like-card">
                            <div className="card-body">
                                <div className="location-management-toolbar city-toolbar">
                                    <div className="location-filter-group">
                                        <label htmlFor="countryCode" className="update">Select Country *</label>
                                        <select id="countryCode" className="form-control" onChange={this.handleChange} required>
                                            <option value="0">Select one</option>
                                            { CountryOptions }
                                        </select>  
                                    </div>
                                    <div className="location-filter-group">
                                        <label htmlFor="stateCode" className="update">Select State *</label>
                                        <select id="stateCode" className="form-control" onChange={this.handleChange} required>
                                            <option value="0">Select one</option>
                                            { StateOptions }
                                        </select>  
                                    </div>
                                </div>

                                <div className="table-wrapper contest-submissions-table-responsive contest-like-table-responsive">
                                    <table className="table event-table contest-submissions-table contest-like-table location-management-table city-management-table">
                                        <thead>
                                            <tr>
                                                <th className="location-sno-col">Serial number</th>
                                                <th>Name</th>
                                                <th>Country Code</th>
                                                <th>State Code</th>
                                                {/* <th scope="col">Status</th> */}
                                                {/* <th scope="col">Actions</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                          {DataList.length > 0 ? (
                                            bodyData
                                          ) : (
                                            <tr>
                                              <td colSpan="4" className="table-loading-cell">No cities found.</td>
                                            </tr>
                                          )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }    
        
}
export default CityManagement;